import { Injectable } from '@angular/core';

export interface FlashMessageOptions {
  timeout?: number;
  type?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FlashMessagesService {
  show: (text?: string, options?: FlashMessageOptions) => void;
  grayOut: (value: boolean) => void;
}
